import { Extension } from "../../core/extension";
import { ReactNodeView } from "../../react";
import { whiteboardNodesSpec } from "./nodes";
import { SlashCommandGroup, } from "../../core/types";
import { WhiteboardNodeView } from "./components/WhiteboardNodeView/WhiteboardNodeView";
import { createWhiteboardNode } from "./commands";
export class WhiteboardExtension extends Extension {
    constructor(service, filestackService) {
        super();
        this.service = service;
        this.filestackService = filestackService;
    }
    addNodes(nodes) {
        return nodes.append(whiteboardNodesSpec());
    }
    addPlugins(schema, plugins, _context) {
        return plugins.concat([]);
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        var _a, _b;
        return {
            ...nodeViews,
            whiteboard: ReactNodeView.create({
                portalContainer,
                component: WhiteboardNodeView,
                extraProps: {
                    service: (_b = (_a = this.service) === null || _a === void 0 ? void 0 : _a.withPortalContainer(portalContainer)) === null || _b === void 0 ? void 0 : _b.withFilestackService(this.filestackService),
                    filestackService: this.filestackService,
                },
            }),
        };
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            this.service.isEditable()
                ? {
                    label: "Whiteboard",
                    description: "Insert a whiteboard diagram",
                    group: SlashCommandGroup.Advanced,
                    icon: "reports",
                    iconSize: "L",
                    iconColor: "#00cbc5",
                    command: (match, view) => {
                        view.dispatch(view.state.tr.deleteRange(match.range.from, match.range.to));
                        const node = createWhiteboardNode(view, 500, 500);
                        view.dispatch(view.state.tr.replaceSelectionWith(node));
                    },
                }
                : undefined,
        ].filter(Boolean);
    }
}
